module.exports = __webpack_public_path__ + "static/img/Cassius-Tia.d8063a7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Cassius-Tia.jpg
// module id = Wp/6
// module chunks = 0